<template>
	<div id="ag-grid-demo">
		<div id="grid-loader" class="vx-card vs-con-loading__container p-6">
			<!-- TABLE ACTION ROW -->
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 mb-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowModelType="rowModelType"
				rowSelection="multiple"
				:enableRangeSelection="true"
				:suppressCopyRowsToClipboard="true"
				colResizeDefault="shift"
				:suppressDragLeaveHidesColumns="true"
				:animateRows="false"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:suppressRowClickSelection="true"
				:rowClassRules="rowClassRules"
				:statusBar="statusBar"
				:sideBar="sideBar"
				:cacheBlockSize="500"
				:rowHeight="38"
				:headerHeight="40"
				@grid-ready="onGridReady"
				@displayed-columns-changed="displayedColumnsChanged"
				@column-resized="onColumnResized">
			</ag-grid-vue>
			<div class="vx-row">
				<div class="vx-col w-full">
					<vs-pagination
						:total="totalPages"
						:max="maxPageNumbers"
						v-model="currentPage"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {AgGridVue} from "ag-grid-vue"
	import "ag-grid-enterprise";

	import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
	import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss'

	// Cell Renderer
	import CellRendererDate from '@/components/ag-grid-tables/cell-renderer/CellRendererDate.vue'

	export default {
		components: {
			AgGridVue,

			// Cell Renderer
			CellRendererDate,
		},
		data() {
			return {
				isGridReady: false,
				gridOptions: {},
				gridCount: 0,
				maxPageNumbers: 7,
				gridApi: null,
				defaultColDef: {
					sortable: true,
					resizable: true,
					suppressMenu: true,
					suppressMovable: false,
					filterParams: {
						suppressAndOrCondition: true,
						newRowsAction: 'keep'
					},
				},
				rowClassRules: null,
				statusBar: null,
				sideBar: null,
				rowModelType: "serverSide",
				modifiedColumnState: null,
				columnDefs: [
				{
					headerName: 'Domain',
					field: 'domain',
					minWidth: 275,
					filter: "agTextColumnFilter",
					pinned: 'left',
				},
				{
					headerName: 'ID',
					field: 'id',
					filter: false,
					minWidth: 100,
					sort: 'desc',
				},
				{
					headerName: 'UUID',
					field: 'uuid',
					minWidth: 150,
					filter: "agTextColumnFilter",
					hide: true
				},
				{
					headerName: 'IP Address',
					field: 'ip_address',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Coupon',
					field: 'coupon',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Coupon Sent At',
					field: 'coupon_sent_at',
					filter: "agDateColumnFilter",
					minWidth: 235,
					cellRendererFramework: 'CellRendererDate'
				},
				{
					headerName: 'Redirect Response At',
					field: 'redirect_response_at',
					filter: "agDateColumnFilter",
					minWidth: 235,
					cellRendererFramework: 'CellRendererDate'
				},
				{
					headerName: 'Created At',
					field: 'created_at',
					filter: "agDateColumnFilter",
					minWidth: 235,
					cellRendererFramework: 'CellRendererDate'
				},
				{
					headerName: 'Updated At',
					field: 'updated_at',
					filter: "agDateColumnFilter",
					minWidth: 235,
					cellRendererFramework: 'CellRendererDate'
				},
				],

				// Cell Renderer Components
				components: {
					CellRendererDate,
				}
			}
		},
		watch: {
			windowWidth(val) {
				// Toggle colummn movable
				this.toggleColumnMovable(val);
				// Toggle colummn pinning
				this.toggleColumnPinned(val);
			},
			totalPages() {
				if (this.gridApi) {
					this.gridCount = this.gridApi.getDisplayedRowCount() - 1
				} else {
					this.gridCount = 0
				}
			},
			modifiedColumnState: {
				handler: function(val) {
					let columnState = JSON.parse(localStorage.getItem('column-state')) ? JSON.parse(localStorage.getItem('column-state')) : {};

					// Add / Replace current table's state
					columnState[this.$route.name] = val;
					
					localStorage.setItem('column-state', JSON.stringify(columnState));
				},
				deep: true
			},
		},
		computed: {
			windowWidth: function () {
				return this.$store.state.windowWidth;
			},
			currentTimestamp: function () {
				return this.$store.getters.getCurrentTimestamp;
			},
			formattedTimestamp: function () {
				return this.currentTimestamp != null ? new Date(this.currentTimestamp) : this.currentTimestamp;
			},
			paginationPageSize() {
				if (this.gridApi) {
					return this.gridApi.paginationGetPageSize()
				} else {
					return 100
				}
			},
			totalPages() {
				if (this.gridApi) {
					return this.gridApi.paginationGetTotalPages()
				} else {
					return 0
				}
			},
			currentPage: {
				get() {
					if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
					else return 1
				},
				set(val) {
					this.gridApi.paginationGoToPage(val - 1);
				}
			},
		},
		methods: {
			showDivLoading(){
				this.$vs.loading({
					container: '#grid-loader',
					scale: 0.45
				});
			},
			hideDivLoading(){
				this.$vs.loading.close("#grid-loader > .con-vs-loading");
			},
			toggleColumnMovable(val) {
				if (val <= 576) {
					this.defaultColDef['suppressMovable'] = true;
				} else {
					this.defaultColDef['suppressMovable'] = false;
				}
			},
			toggleColumnPinned(val) {
				if(val <= 576) {
					this.maxPageNumbers = 4;
					this.gridOptions.columnApi.setColumnPinned('domain', null);
				}
				else {
					this.gridOptions.columnApi.setColumnPinned('domain', 'left')
				}
			},
			onColumnResized() {
				this.gridApi.resetRowHeights();
			},
			sizeColumnsToFit() {
				this.gridApi.sizeColumnsToFit();
			},
			displayedColumnsChanged() {
				if (this.isGridReady) {
					this.modifiedColumnState = this.gridOptions.columnApi.getColumnState();
				}
			},
			setAgGridState(route) {
				// Set Column State
				let columnState = localStorage.getItem('column-state') ? JSON.parse(localStorage.getItem('column-state'))[route] : null;

				if(columnState) {
					this.gridOptions.columnApi.setColumnState(columnState);
					
					// Resize to fit columns
					this.sizeColumnsToFit();
				}
			},
			onGridReady(params) {
				let self = this;
				// Set Data Source
				params.api.setServerSideDatasource({
					getRows(params) {
						self.$axiosSecure.post('/ag-grid/godaddy-redirect-requests', params.request)
							//TODO: add lastRow check
							.then(response => {
								if (response.data) {
									// clear all overlays
									self.gridApi.hideOverlay();
									params.successCallback(response.data.data);
								} else {
									// clear all overlays
									self.gridApi.hideOverlay();
									// show 'no rows' overlay
									self.gridApi.showNoRowsOverlay();
									params.successCallback([], 0);
								}

								// Set isGridReady Flag
								self.isGridReady = true;

								// Set Column State
								self.setAgGridState(self.$route.name);
							})
							.catch(error => {
								params.failCallback();
								
								// Error notification
								if (error.response.status == 401) {
									this.$vs.notify({
										color: 'danger',
										title: `Not authorized`,
										text: `You do not have permission to access the resource`
									});
								}
								else if (error.response.status == 403) {
									// Token invalid so logout
									this.$root.$emit('appLogout');
								}
								else {
									this.$vs.notify({
										color: 'danger',
										title: 'Something went wrong',
										text: 'Please contact the server admin'
									});
								}
								// eslint-disable-next-line no-console
								console.log(error);
							})
					}
				});
			},
			getUrlParameter(name) {
				return this.$route.query[name];
			},
			filterAgGrid(model) {
				if (model) {
					this.gridApi.setFilterModel(model);
					this.gridApi.onFilterChanged();
				}
			},
		},
		beforeMount() {
			// Reset movable columns on mobile
			this.toggleColumnMovable(this.windowWidth);

			// Set Grid sidebar
			this.sideBar = {
				toolPanels: [
				{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel",
					toolPanelParams: {
						suppressRowGroups: true,
						suppressValues: true,
						suppressPivots: true,
						suppressColumnFilter: true,
						suppressPivotMode: true,
						suppressSideButtons: true,
						suppressColumnSelectAll: true,
						suppressColumnExpandAll: true
					}
				},
				{
					id: 'filters',
					labelDefault: 'Filters',
					labelKey: 'filters',
					iconKey: 'filter',
					toolPanel: 'agFiltersToolPanel',
				},
				],
			};
		},
		mounted() {
			this.gridApi = this.gridOptions.api;

			// Resize to fit columns
			this.sizeColumnsToFit();

			// Reset pinned columns on mobile
			this.toggleColumnPinned(this.windowWidth);

			// Page Refresh Event
			this.$root.$on('refreshPage', () => {
				// Reset filters
				this.gridApi.setFilterModel(null);
				// Reset selection
				this.gridApi.deselectAll();
				// Reset sort
				this.gridApi.setSortModel([
					{
						colId: "scan_date",
						sort: "desc"
					}
				]);
			});

			// Page Download Event
			this.$root.$on('downloadPage', () => {
				// Show loader
				this.showDivLoading();

				let filterModel = this.gridApi.getFilterModel();
				let sortModel = this.gridApi.getSortModel();
				this.$axiosSecure.post('/download/godaddy-redirect-requests', {
						'endRow': null,
						'filterModel': filterModel,
						'groupKeys': [],
						'pivotCols': [],
						'pivotMode': false,
						'rowGroupCols': [],
						'sortModel': sortModel,
						'startRow': null,
						'valueCols': [],
						'title': "CSV Report Download",
						'message': '<strong>GoDaddy Log Table</strong> is ready to download here: <a href="#LINK#">download</a>',
						'type': 'CSV_DOWNLOAD',
					})
					.then(() => {
						this.$root.$emit('refreshNotifications');

						// Hide loader
						this.hideDivLoading();

						// Success notification
						this.$vs.notify({
							color: 'success',
							title: 'CSV download',
							text: 'Your download has been queued'
						})
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							// Hide loader
							this.hideDivLoading();

							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
			});
		},
		destroyed() {
			// Unbind Button Event Listeners
			this.$root.$off('refreshPage');
			this.$root.$off('downloadPage');
		}
	}

</script>